import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { Facebook } from '../classes/Facebook';
import { IFacebookEventListener } from '../classes/IFacebookEventListener';

@Component({
  selector: 'app-register-choice',
  templateUrl: './register-choice.component.html',
  styleUrls: ['./register-choice.component.scss']
})
export class RegisterChoiceComponent extends BaseComponent implements OnInit, OnDestroy, IFacebookEventListener {

  facebook: Facebook = Facebook.getInstance();
  @Output() onRegisterNow = new EventEmitter();
  @Output() facebookConnected = new EventEmitter();
  @Output() loginClicked = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
    this.facebook.addEventListener(this);
  }

  ngOnDestroy(): void {
    this.facebook.removeEventListener(this);
  }

  onFacebookConnected(response: any) {
    this.facebookConnected.emit(response);
    this.facebook.removeEventListener(this);
  }

  registerNow() {
    this.onRegisterNow.emit();
  }

  FBLogin() {
    this.facebook.login()
  }

  loginClick() {
    this.loginClicked.emit();
  }

}
